import { Typography } from '@/components/primitives/Typography';
import PassengerInfo from '@/components/purchase/checkout/PassengerInfo';
import type { PersonDataField } from '@/hooks/usePersonFieldRenderer';
import { cn } from '@/utils/cn';
import { getPassengerName } from '@/utils/passenger';
import type { CheckoutValues } from '@/utils/zodSchema';
import type { FC } from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

interface PassengerListProps {
  formFields: Array<PersonDataField>;
}

const PassengerList: FC<PassengerListProps> = ({ formFields }) => {
  const { control, watch } = useFormContext<CheckoutValues>();
  const { fields } = useFieldArray({
    control,
    name: 'passengers',
  });
  const passengers = watch('passengers');

  return fields.map(({ id }, index) => {
    const passenger = passengers[index];

    return (
      <div
        key={id}
        className={cn('flex flex-col gap-3 tablet:flex-row tablet:gap-6', {
          'border-b border-neutral-pale pb-3': index < fields.length - 1,
        })}
        data-testid={`passengers-${index}-content`}
      >
        <div className="tablet:flex-1">
          <Typography
            variant="body1-bold"
            className="whitespace-normal break-all text-dark"
            asChild
          >
            <h3>{getPassengerName(passenger, index)}</h3>
          </Typography>
        </div>
        <PassengerInfo
          formFields={formFields}
          prefix={`passengers[${index}]`}
        />
      </div>
    );
  });
};

export default PassengerList;
